import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { ArquivoUploadTableModule } from '../table';
import { ArquivoUploadModalModule } from '../modal';

import { ArquivoUploadCardViewComponent } from './arquivo-upload-card-view.component';

@NgModule({
    imports: [
        SharedModule,
        ArquivoUploadTableModule,
        ArquivoUploadModalModule
    ],
    declarations: [
        ArquivoUploadCardViewComponent
    ],
    exports: [
        ArquivoUploadCardViewComponent
    ]
})
export class ArquivoUploadCardViewModule { }
